import { createStyles, makeStyles } from "@material-ui/core/styles";

import { DARKER_GREY, ALMOST_WHITE, LIGTHER_GREY, SPUN_PEARL, HEATHER, SHARK } from "constants/colors";

export const getModalStyle = (width) => {
  return {
    width: `${width}%`,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
};

export const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      minWidth: 150,
      position: "absolute",
      border: "2px solid #000",
      fontFamily: "Lato, sans-serif",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      backgroundColor: DARKER_GREY,
      lineHeight: "1.25em",
      borderRadius: "8px",
      transition: "all 400ms",
    },
    header: {
      textAlign: "center",
      position: "relative",
      fontSize: "20px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.25",
      letterSpacing: "normal",
      color: ALMOST_WHITE,
    },
    content: {
      maxHeight: 450,
      overflowY: "auto",
      padding: "24px 0px !important",
    },
    message: {
      fontSize: "14px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.25",
      letterSpacing: "normal",
      color: ALMOST_WHITE,
      textAlign: "center",
    },
    button: {
      cursor: "pointer",
      fontFamily: "Lato, sans-serif",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "16px",
      lineHeight: "19px",
      letterSpacing: "0.25px",
      flex: "none",
      alignSelf: "center",
      padding: "9px 10px",
    },
    buttonCancel: {
      background: "transparent",
      border: `1px solid ${SPUN_PEARL}`,
      boxSizing: "border-box",
      borderRadius: "8px",
      color: LIGTHER_GREY,
      marginRight: "15px",
    },
    buttonAccept: {
      border: "none",
      background: HEATHER,
      borderRadius: "8px",
      color: SHARK,
      marginRight: "22px",
      "&:active,&:focus": {
        background: HEATHER,
        color: SHARK,
      },
    },
  })
);
